import DOMPurify from 'dompurify';

export const NARRATION_TEXT_MAX_LENGTH = 2500;

export const cleanNarrationText = (text: string): string =>
  (
    DOMPurify.sanitize(text, { ALLOWED_TAGS: [], RETURN_DOM: true })
      .textContent || ''
  )
    .replace(/\s+/g, ' ')
    .trim();

export const narrationTextLength = (text: string): number =>
  Array.from(cleanNarrationText(text)).length;
